import React from 'react';
import TweenOne from 'rc-tween-one';
import SvgDrawPlugin from 'rc-tween-one/lib/plugin/SvgDrawPlugin';
import './BannerImage.css';

TweenOne.plugins.push(SvgDrawPlugin);

let delay = 0;
function setAddDelay() {
  delay += 100;
  return delay;
}

const duration = 400;

const animate = {
  scale: {
    scale: 0,
    opacity: 0,
    type: 'from',
    ease: 'easeOutQuad',
    duration,
  },
  alpha: {
    opacity: 0,
    type: 'from',
    ease: 'easeOutQuad',
    duration,
  },
  y: {
    y: -30,
    opacity: 0,
    type: 'from',
    ease: 'easeOutQuad',
    duration,
  },
  yBig: {
    y: -120,
    opacity: 0,
    type: 'from',
    ease: 'easeOutQuad',
    duration,
  },
  draw: {
    style: { SVGDraw: 0 },
    type: 'from',
    ease: 'easeOutQuad',
  },
  loop: {
    yoyo: true,
    repeat: -1,
    duration: 2500,
  },
};
const backgroundImage = require('../../assets/images/Artwork.png');
export default function BannerImage() {
  return (
      <div className="paradi-banner-image mr-5">
        <img src={backgroundImage} alt="banner image"/>
      </div>
  );
}
